import React from "react";

const PlayIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="41.5999"
        height="41.599"
        viewBox="0 0 52 52"
      >
        <path
          id="play-circle-regular"
          d="M46.13,32.113,27.678,20.9a2.521,2.521,0,0,0-3.743,2.2V44.9a2.522,2.522,0,0,0,3.743,2.2L46.13,36.516A2.524,2.524,0,0,0,46.13,32.113ZM60,34A26,26,0,1,0,34,60,26,26,0,0,0,60,34ZM13.032,34A20.968,20.968,0,1,1,34,54.968,20.962,20.962,0,0,1,13.032,34Z"
          transform="translate(-8 -8)"
          fill="#1198ff"
        />
      </svg>
    </>
  );
};

export default PlayIcon;
